import React, { createContext, useState, useEffect } from "react"
import { deliveryPrice, distanceBetween } from "@antoine-lb/business-logic"
export const LocationContext = createContext(null)

export default ({ children }) => {
  const [location, setLocationState] = useState({})
  const [isSelected, setIsSelected] = useState(false)
  const [isLocationValid, setIsLocationValid] = useState(false)
  const [deliveryZone, setDeliveryZone] = useState(undefined)
  const [isTakeaway, setIsTakeaway] = useState(false)
  const [notes, setNotesState] = useState(undefined)
  const [hour, setHourState] = useState(undefined)
  const [date, setDateState] = useState(undefined)

  useEffect(() => {
    try {
      const location = JSON.parse(localStorage.getItem("location"))
      if (location && location.place_name) {
        setLocation(location)
        setNotesState(location.notes)
        setHourState(location.hour)
        setDateState(location.date)
      }
    } catch (err) {
      setLocation({})
    }
  }, [])

  const setLocation = location_submited => {
    if (location_submited.place_name !== undefined) {
      setIsSelected(true)
    } else {
      setIsSelected(false)
    }

    if (
      (location_submited.is_address === true &&
        location_submited.zipcode !== undefined,
      location_submited.type === "delivery")
    ) {
      setIsLocationValid(true)
      const distanceKm = distanceBetween(
        -33.420679,
        -70.610197,
        location_submited.lat,
        location_submited.lon
      )

      setDeliveryZone({
        price_in_cent: deliveryPrice(distanceKm),
        distanceInKm: distanceKm,
      })
    } else if (
      location_submited.type === "takeaway" &&
      location_submited.place_name ===
        "Baco, Nueva de Lyon 113, Providencia, Región Metropolitana de Santiago 7500000, Chile"
    ) {
      setIsTakeaway(true)
      setIsLocationValid(true)
    } else {
      setIsLocationValid(false)
      setDeliveryZone(false)
      setIsTakeaway(false)
    }

    setLocationState(location_submited)
    localStorage.setItem("location", JSON.stringify(location_submited))
  }

  const setNotes = notes => {
    setNotesState(notes)
    setLocationState({ ...location, notes })
    localStorage.setItem("location", JSON.stringify({ ...location, notes }))
  }

  const setHour = hour => {
    setHourState(hour)
    setLocationState({ ...location, hour })
    localStorage.setItem("location", JSON.stringify({ ...location, hour }))
  }

  const setDate = date => {
    setDateState(date)
    setLocationState({ ...location, date })
    localStorage.setItem("location", JSON.stringify({ ...location, date }))
  }

  return (
    <LocationContext.Provider
      value={{
        location,
        setLocation,
        isSelected,
        isLocationValid,
        deliveryZone,
        isTakeaway,
        notes,
        hour,
        date,
        setNotes,
        setHour,
        setDate,
      }}
    >
      {children}
    </LocationContext.Provider>
  )
}
